export class RingBuffer<TEntry> {

  private maxBufferSize = 10000;
  private ringBuffer: TEntry[] = new Array(this.maxBufferSize);
  private writeIndex = 0;
  private isFull = false;

  getEntries(): TEntry[] {
    const entries = !this.isFull
      ? this.ringBuffer.slice(0, this.writeIndex)
      : [...this.ringBuffer.slice(this.writeIndex), ...this.ringBuffer.slice(0, this.writeIndex)];
    return entries;
  }

  add(entry: TEntry): void {
    this.ringBuffer[this.writeIndex] = entry;
    this.writeIndex = (this.writeIndex + 1) % this.maxBufferSize;
    if (this.writeIndex === 0) {
      this.isFull = true;
    }
  }

  setMaxBufferSize(newMaxBufferSize: number): void {
    if (newMaxBufferSize <= 0 || newMaxBufferSize === this.maxBufferSize) {
      return;
    }
    const entries = this.getEntries();
    const entriesToKeep = entries.length > newMaxBufferSize
      ? entries.slice(entries.length - newMaxBufferSize) 
      : entries;
    this.maxBufferSize = newMaxBufferSize;
    this.ringBuffer = new Array(this.maxBufferSize);
    for (let i = 0; i < entriesToKeep.length; i++) {
      this.ringBuffer[i] = entriesToKeep[i];
    }
    this.writeIndex = entriesToKeep.length % this.maxBufferSize;
    this.isFull = entriesToKeep.length === this.maxBufferSize;
  }
}
